import {FC} from 'react'
import DateRangePicker, {DateRangePickerProps} from '@wojtekmaj/react-daterange-picker'
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css'
import 'react-calendar/dist/Calendar.css'
import {KTIcon} from '../_metronic/helpers'

const CustomDateRangePicker: FC<DateRangePickerProps> = ({...props}: DateRangePickerProps) => {
  return (
    <DateRangePicker
      dayPlaceholder="dd"
      monthPlaceholder="mm"
      yearPlaceholder="yyyy"
      calendarIcon={<KTIcon iconName="calendar-8" className="fs-2 text-info" />}
      clearIcon={<KTIcon iconName="cross" className="fs-1 text-gray-700" />}
      format="dd-MM-yyyy"
      {...props}
    />
  )
}

export default CustomDateRangePicker
